function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 4;



//////////////////
// WEBPACK FOOTER
// ./src/features nonrecursive \.js$
// module id = 4
// module chunks = 0